import { render, staticRenderFns } from "./insuranceDetail.vue?vue&type=template&id=4c3fae93"
import script from "./insuranceDetail.vue?vue&type=script&lang=js"
export * from "./insuranceDetail.vue?vue&type=script&lang=js"
import style0 from "./insuranceDetail.vue?vue&type=style&index=0&id=4c3fae93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports